import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { ChipButton, ChipGroup, ChipLabel } from 'components/ChipGroup';
import Icon from 'components/Icon';
import { useAppSelector } from 'store/hooks';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { selectIsActiveContentZoomed } from 'features/content-zoom/contentZoomSlice';

const Root = styled(ChipGroup)(({ theme }) => ({
  gap: theme.spacing(1),
  height: 32,
  borderRadius: 32 / 2,
  backgroundColor: alpha(theme.palette.common.black, 0.6),
  overflow: 'hidden',
}));

const PageButton = styled(ChipButton)(({ theme }) => ({
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.black, 0.8),
  },
}));

type GalleryPaginationProps = {
  goToPage: (index: number) => void;
  currentPage: number;
};

export const GalleryPagination = ({ goToPage, currentPage }: GalleryPaginationProps) => {
  const { isMobile } = useBreakpoints();

  const isZoomed = useAppSelector(selectIsActiveContentZoomed);

  if (isZoomed) {
    return null;
  }

  const goBack = () => {
    goToPage(currentPage - 1);
  };

  const goForward = () => {
    goToPage(currentPage + 1);
  };

  return (
    <Box
      className={!isMobile ? 'hover-child' : ''}
      sx={{
        position: 'absolute',
        bottom: '6px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 3,
      }}
    >
      <Root>
        <PageButton onClick={goBack}>
          <Icon name="back" />
        </PageButton>
        <ChipLabel>{currentPage + 1}</ChipLabel>
        <PageButton onClick={goForward}>
          <Icon name="forward" />
        </PageButton>
      </Root>
    </Box>
  );
};
